module.exports = __webpack_public_path__ + "static/media/STEAM-BNB.4248da37.svg";